import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/state/store'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = new VueI18n({
  locale: store.state.layout.local,
  fallbackLocale: store.state.layout.local,
  messages: loadLocaleMessages()
})

// Watch for changes in the store's locale and update i18n locale accordingly
store.watch(
  (state) => state.layout.local,
  (newLocale) => {
    i18n.locale = newLocale
  }
)

export default i18n
